exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header{height:10vh;background:linear-gradient(90deg,#0d0e2c,#511b75,#ff497a);display:flex;align-items:center}header>div{display:flex;justify-content:space-between}header>div>h6{display:none}@media (max-width:767px){header{height:10vh;position:fixed;width:100%;z-index:10}header>div>h6{display:block;color:#ffc107;cursor:pointer;font-size:1.5rem;text-align:right;width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1539b5b0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header.vue
// module id = 265
// module chunks = 0